import { contactFactory } from '@trukt/factories/contactFactory';

import { Factory } from 'fishery';
import { SearchClientContactsResponse } from './ClientContactServices.types';

export const searchClientContactsResponseFactory = Factory.define<SearchClientContactsResponse>(
  () => ({
    page: 1,
    results: contactFactory
      .buildList(2)
      .map((contact) => ({ ...contact, active: contact.isActive })),
    rowCount: 25,
    next: false,
    rows: 25,
  }),
);
